import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { DossierSandboxService } from '@sc/data-access-state-management';
import { AuthService } from '@sc/feature-auth-okta';
import { DeclarationConditions } from '@sc/utils';
import { of } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';

export const DossierCompleteGuardCanActivate: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const dossierSB = inject(DossierSandboxService);
  const router = inject(Router);
  const declarationConditions = inject(DeclarationConditions);
  const authService = inject(AuthService);

  const dossierNumber = authService.getCurrentDossierId();

  if (!dossierNumber) {
    return of(true);
  }

  return dossierSB.getOrFetchDossier(dossierNumber).pipe(
    switchMap(() => dossierSB.dossier$),
    filter((dossier) => !!dossier),
    take(1),
    map((dossier) => {
      return (declarationConditions?.isDossierComplete(dossier) ||
        dossier?.state === 'ABANDONED') &&
        dossier?.appointment?.status !== 'MODIFIED' &&
        dossier?.requestAppointment?.status !== 'MODIFIED'
        ? router.parseUrl('/declaration/declaration-end')
        : true;
    })
  );
};
